import {Http} from '../../../Data/config/Http';
import {API_ROUTES, ApiUtils} from '../../../constants/apiRoutes';
import type {BaseResponse, Pagination} from '../../../Data/types/BaseResponse';
import {unwrapResponse, handleDataSourceError} from '../../../utils/errorHelpers';
import type {SessionSummaryDTO, SessionTrackDTO} from '../models/session.dto';
import type {SessionFilters} from '../models/session.model';

export const MarketerTrackingAPIDataSource = {
  getSessions: async (filters: SessionFilters = {}): Promise<{data: SessionSummaryDTO[]; pagination: Pagination}> => {
    try {
      const url = ApiUtils.buildUrl(
        API_ROUTES.LOCATION_TRACKING.SESSIONS,
        filters as Record<string, unknown>
      );
      const response = await Http.get<BaseResponse<SessionSummaryDTO[]>>(url);
      const raw = response.data;
      const items = unwrapResponse(raw, 'حدث خطأ في جلب قائمة الجلسات');
      return {
        data: Array.isArray(items) ? items : [],
        pagination: raw.pagination || {page: 1, limit: 20, total: 0, totalPages: 1}
      };
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  getSessionDetails: async (sessionId: number | string): Promise<SessionSummaryDTO> => {
    try {
      const response = await Http.get<BaseResponse<SessionSummaryDTO>>(
        API_ROUTES.LOCATION_TRACKING.SESSION_DETAILS(sessionId.toString())
      );
      return unwrapResponse(response.data, 'حدث خطأ في جلب تفاصيل الجلسة');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  getSessionTrack: async (sessionId: number | string): Promise<SessionTrackDTO> => {
    try {
      const response = await Http.get<BaseResponse<SessionTrackDTO>>(
        API_ROUTES.LOCATION_TRACKING.SESSION_TRACK(sessionId.toString())
      );
      return unwrapResponse(response.data, 'حدث خطأ في جلب مسار الجلسة');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  getMarketerSessions: async (
    marketerId: number | string,
    filters: Omit<SessionFilters, 'marketerId'> = {}
  ): Promise<{data: SessionSummaryDTO[]; pagination: Pagination}> => {
    try {
      const url = ApiUtils.buildUrl(
        API_ROUTES.LOCATION_TRACKING.MARKETER_SESSIONS(marketerId.toString()),
        filters as Record<string, unknown>
      );
      const response = await Http.get<BaseResponse<SessionSummaryDTO[]>>(url);
      const raw = response.data;
      const items = unwrapResponse(raw, 'حدث خطأ في جلب سجل جلسات المسوّق');
      return {
        data: Array.isArray(items) ? items : [],
        pagination: raw.pagination || {page: 1, limit: 20, total: 0, totalPages: 1}
      };
    } catch (error) {
      handleDataSourceError(error);
    }
  }
};
